import './Report.css';
import config from "../config.json";
import { Button, Modal } from 'react-bootstrap';
import React, { useContext, useEffect, useState } from "react";
import Select from 'react-select'
//import DatePicker from 'react-datepicker2';
import { MainContext } from "../store/mainContext";
import ReportOnOff from './ReportOnOff';
//import momentJalaali from 'moment-jalaali';
import TimePicker from "react-multi-date-picker/plugins/analog_time_picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import gregorian from "react-date-object/calendars/gregorian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian_en from "react-date-object/locales/gregorian_en"
import gregorian_fa from "react-date-object/locales/gregorian_fa";

import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import utils from "../Services/dateTimeUtils";
//import Chart from "react-apexcharts";
export default function Report({ show, handleClose, device }) {
    const [showIng, setShowIng] = useState(false);
    const [data, setData] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const [valueDate, setValueDate] = useState(
        {
            from: new DateObject({
                date: new Date(),
                hour: 0,
                minute: 0,
                second: 0,
            }),
            too: new DateObject({
                date: new Date(),
                hour: 23,
                minute: 59,
                second: 0,
            })
        })


    //const now = momentJalaali();
    const [form, setForm] = useState({
        id: 0,
        mode: 1,
        dateMode: 1,
        from: valueDate.from.toDate().toISOString(),//momentJalaali(now.format('jYYYY/jMM/jDD') + ' 00:00', 'jYYYY/jMM/jDD HH:mm'),
        too: valueDate.too.toDate().toISOString(), //momentJalaali(now.format('jYYYY/jMM/jDD') + ' 12:59', 'jYYYY/jMM/jDD HH:mm'),
        userAccountId: 0,
        modeAccount: 0
    });
    const [list, setList] = useState([]);
    const { devices } = useContext(MainContext);

    const [accountList, setAccountList] = useState([]);
    const [isloadUserAccountList, setIsloadUserAccountList] = useState(false)
    const UserAccountList = async () => {
        setIsloadUserAccountList(true);
        await noronServices.UserAccountList()
            .then(({ data }) => {
                setIsloadUserAccountList(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setAccountList(data.payload);
            })
            .catch(err => {
                setIsloadUserAccountList(false);
            });
    }

    const handleCloseIng = () => {
        setShowIng(false);
        handleClose([], null);
    }



    const [deviceChoice, setDeviceChoice] = useState({})
    const [accountChoice, setAccountChoice] = useState({})
    useEffect(() => {
        if (device) {
            console.log('device', device);
            setForm({ ...form, id: device.id });
            setDeviceChoice({ value: device.id, label: device.deviceName });
        }
    }, [device]);
    useEffect(() => {
        if (devices && devices.length > 0) {
            setForm({ ...form, modeAccount: 0, id: devices[0].id });
            setDeviceChoice({ value: devices[0].id, label: devices[0].deviceName });
        }
    }, [devices]);
    useEffect(() => {
        console.log('form', form)
    }, [form]);


    const handleAddIng = async (e) => {
        e.preventDefault();
        if (form.mode == 10 && form.modeAccount == 0 && (!form.id || form.id == 0)) {
            toast.error('دستگاهی مشخص نشده است', { theme: "colored" });
            return;
        } else if (form.mode == 10 && form.modeAccount == 1 && form.userAccountId == 0) {
            toast.error('کاربر زیر مجموعه مشخص نشده است', { theme: "colored" });
            return;
        }
        else if (form.mode != 10 && (!form.id || form.id == 0)) {
            toast.error('دستگاهی مشخص نشده است', { theme: "colored" });
            return;
        }
        setIsLoading(true);
        setData(0);
        const method = form.mode == 8 ? noronServices.ReportTemp : noronServices.ListReport;
        await method(form)
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                if (form.mode == "5" || form.mode == "6" || form.mode == "3" || form.mode == "10" || form.mode == "11") {
                    setList([]);
                    setData(data.payload);
                } else if (form.mode == "1") {
                    if (data.payload.length <= 0) {
                        toast.error('داده ای یافت نشد', { theme: "colored" });
                        return;
                    }
                    data.payload.map(item => item.popup = false);
                    setShowIng(false);
                    handleClose(data.payload, form);
                }
                else
                    setList(data.payload);
            })
            .catch(err => {
                setIsLoading(false);
            });
    }
    /*
        const handleChangeDate = (value, name) => {
            setForm({ ...form, [name]: value });
            setList([]);
            setData(0);
        };*/

    const doLink = (csvContent) => {
        csvContent = "data:text/csv;charset=utf-8," + csvContent;// + rows.map(e => e.join(",")).join("\n");
        let encodedUri = encodeURI(csvContent);
        let link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "data.csv");
        document.body.appendChild(link);
        link.click();
    }


    const doExport = (ee, rows) => {
        let csvContent = `تاریخ,ساعت,${form.mode == "2" ? "سرعت"
            : form.mode == "3" ? "زمان روشن بودن خودرو"
                : form.mode == "4" ? "محدوده"
                    : form.mode == "5" ? "مسافت"
                        : form.mode == "6" ? "مصرف سوخت"
                            : form.mode == "8" ? "دما"
                                : ""}\n`;
        rows.map(e => {
            let ddd = `${e.dtFa},${e.time},${form.mode == "2" ? e.speed
                : form.mode == "3" ? e.switch
                    : form.mode == "8" ? e.temp
                        : e.speed}\n`;
            csvContent += ddd;
        });
        return doLink(csvContent);
    }
    const doExport2 = (ee, rows) => {
        let csvContent = `از تاریخ,از ساعت,تا تاریخ,تا ساعت,وضعیت,به مدت\n`;
        rows.map(e => {
            let ddd = `${e.dtFromFa},${e.timeFrom},${e.dtToFa},${e.timeTo},${e.switch == 0 ? 'خاموش' : 'روشن'},${utils.toHHMM(e.len)}\n`;
            csvContent += ddd;
        });
        return doLink(csvContent);
    }


    const doExport3 = (e) => {
        let link = document.createElement("a");
        link.setAttribute("href", config.apiUrl + '/' + data);
        link.setAttribute("target", "_blank");
        link.setAttribute("download", data);
        document.body.appendChild(link);
        link.click();
    }

    useEffect(() => {
        setShowIng(show);
        if (show) {
            UserAccountList();

        }
    }, [show]);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);
    return (
        <>
            <Modal show={showIng} onHide={handleCloseIng} id="modalPatient"
                centered={!isMobile} scrollable>
                <Modal.Header closeButton>
                    <Modal.Title className="colorRed">تهیه گزارش</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="form-floating  mb-3">
                            <select className="form-select" aria-label="Default select example"
                                name="mode"
                                value={form.mode}
                                onChange={e => {
                                    const value = e.target.value;
                                    const temp = (value == "3" || value == "5" || value == "10");
                                    setForm({
                                        ...form,
                                        mode: value,
                                        modeAccount: temp ? form.modeAccount : 0,
                                        userAccountId: 0
                                    })
                                }}>
                                <option value="1">مسیر حرکت</option>
                                {/*<option value="4">محدوده خودرو</option>*/}
                                <option value="5">مسافت پیموه شده</option>
                                {/*<option value="9">مسافت پیموه شده کلیه خودروها</option>*/}
                                <option value="7">زمان روشن و خاموش شدن خودرو</option>
                                <option value="6">مصرف سوخت</option>
                                {/*<option value="10"> مصرف سوخت خودروهای سنگین</option>*/}
                                {/*<option value="12">مصرف سوخت فصلی</option>*/}
                                <option value="2">سرعت خودرو</option>
                                <option value="3">روشن بودن خودرو</option>
                                {/*<option value="11">باتری</option>*/}
                                <option value="8">دما</option>
                            </select>
                            <label htmlFor="floatingSelect">نوع گزارش</label>
                        </div>
                        {devices && devices.length > 1 &&
                            <>
                                <div className="row mt-3">
                                    <div className="col-auto">
                                        <div className="form-check">
                                            <input
                                                disabled={!((form.mode == "3" || form.mode == "5" || form.mode == "10" || form.mode == "12"))}
                                                checked={form.modeAccount == 2}
                                                onChange={(e) => {
                                                    setDeviceChoice({})
                                                    setForm({ ...form, modeAccount: 2, userAccountId: 0, id: -1 })
                                                }
                                                }
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="flexRadioDefault1" />
                                            <label
                                                disabled={form.mode != 10}
                                                className="form-check-label"
                                                htmlFor="flexRadioDefault1">
                                                کلیه خودروها
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-auto">
                                        <div className="form-check">
                                            <input
                                                checked={form.modeAccount == 0}
                                                onChange={(e) => setForm({ ...form, modeAccount: 0, userAccountId: 0 })}
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="flexRadioDefault1" />
                                            <label
                                                disabled={form.mode == 10}
                                                className="form-check-label"
                                                htmlFor="flexRadioDefault1">
                                                انتخاب خودرو
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <Select
                                            isDisabled={form.modeAccount != 0}
                                            className=' '
                                            placeholder=""
                                            options={devices.map(x => ({ value: x.id, label: x.deviceName }))}
                                            isRtl={true}
                                            value={deviceChoice}
                                            //defaultValue={device ? {value:device.id,label:device.name} : {}}
                                            onChange={
                                                (newValue, actionMeta) => {
                                                    console.log(newValue);
                                                    setDeviceChoice(newValue)
                                                    setForm({ ...form, id: newValue.value });
                                                }
                                            }
                                        />
                                    </div>
                                </div>
                            </>
                        }
                        {accountList.length > 0 &&
                            <div className="row mt-1">
                                <div className="col-auto">
                                    <div className="form-check">
                                        <input
                                            disabled={form.mode != 10}
                                            checked={form.modeAccount == 1}
                                            onChange={(e) => setForm({ ...form, modeAccount: 1 })}
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="flexRadioDefault2" />
                                        <label className="form-check-label" htmlFor="flexRadioDefault2">
                                            خودرو زیر مجموعه
                                            {isloadUserAccountList &&
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>}
                                        </label>
                                    </div>
                                </div>
                                <div className="col">
                                    <Select
                                        isDisabled={form.mode != 10 || form.modeAccount != 1}
                                        className=''
                                        placeholder=""
                                        options={accountList.map(x => ({ value: x.subUserId, label: x.displayName + ("nationalCode" in x ? ("-" + x.nationalCode) : "") }))}
                                        isRtl={true}
                                        value={accountChoice}
                                        //defaultValue={device ? {value:device.id,label:device.name} : {}}
                                        onChange={
                                            (newValue, actionMeta) => {
                                                setAccountChoice(newValue)
                                                setForm({ ...form, userAccountId: newValue.value });
                                            }
                                        }
                                    />
                                </div>
                            </div>
                        }

                        <div className="row border rounded mt-3 mb-3">
                            <div className="col">
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="floatingSelect">محدوده زمانی</label>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-auto">
                                        <div className="form-check form-check-inline">
                                            <input
                                                checked={form.dateMode == 1}
                                                onChange={(e) => setForm({ ...form, dateMode: 1 })}
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault2"
                                                id="flexRadioDefault1" />
                                            <label
                                                className="form-check-label"
                                                htmlFor="flexRadioDefault1">
                                                امروز
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="form-check form-check-inline">
                                            <input
                                                checked={form.dateMode == 2}
                                                onChange={(e) => setForm({ ...form, dateMode: 2 })}
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault2"
                                                id="flexRadioDefault1" />
                                            <label
                                                className="form-check-label"
                                                htmlFor="flexRadioDefault1">
                                                از دیروز
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="form-check form-check-inline">
                                            <input
                                                checked={form.dateMode == 3}
                                                onChange={(e) => setForm({ ...form, dateMode: 3 })}
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault2"
                                                id="flexRadioDefault1" />
                                            <label
                                                className="form-check-label"
                                                htmlFor="flexRadioDefault1">
                                                10 روز گذشته
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="form-check form-check-inline">
                                            <input
                                                checked={form.dateMode == 5}
                                                onChange={(e) => setForm({ ...form, dateMode: 5 })}
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault2"
                                                id="flexRadioDefault1" />
                                            <label
                                                className="form-check-label"
                                                htmlFor="flexRadioDefault1">
                                                انتخابی
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {form.dateMode == "5" &&
                            <>
                                <div className="row">
                                    <div className="col">
                                        <div className="  mb-3">
                                            <label
                                                disabled={form.dateMode != "5"}
                                                htmlFor="from"
                                                className="form-label">از تاریخ :</label>
                                            <DatePicker
                                                inputClass="form-control"
                                                portal
                                                format="YYYY/MM/DD HH:mm"
                                                calendar={persian}//gregorian
                                                locale={persian_fa}//gregorian_en
                                                plugins={[<TimePicker hideSeconds />]}
                                                value={valueDate.from}
                                                onChange={value => {
                                                    console.log('date', value.toDate().toISOString());
                                                    //console.log('date2', valueDate.from.format())
                                                    setValueDate({ ...valueDate, from: value })
                                                    setForm({ ...form, from: value.toDate().toISOString() });
                                                    setList([]);
                                                    setData(0);
                                                }} />
                                            {/*
                                            <DatePicker
                                                disabled={form.dateMode != "5"}
                                                className="form-control"
                                                id="from"
                                                // max={moment().add(0, 'days')}
                                                value={form.from}
                                                isGregorian={false}
                                                onChange={value => handleChangeDate(value, "from")}
                                            />*/
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="  mb-3">
                                            <label
                                                disabled={form.dateMode != "5"}
                                                htmlFor="too"
                                                className="form-label">تا تاریخ :</label>
                                            <DatePicker
                                                inputClass="form-control"
                                                portal
                                                format="YYYY/MM/DD HH:mm"
                                                calendar={persian}//gregorian
                                                locale={persian_fa}//gregorian_en
                                                plugins={[<TimePicker hideSeconds />]}
                                                value={valueDate.too}
                                                onChange={value => {
                                                    console.log('date', value.toDate().toISOString());
                                                    //console.log('date2', valueDate.too.format())
                                                    setValueDate({ ...valueDate, too: value })
                                                    setForm({ ...form, too: value.toDate().toISOString() });
                                                    setList([]);
                                                    setData(0);
                                                }} />
                                            {/*
                                            <DatePicker
                                                disabled={form.dateMode != "5"}
                                                className="form-control"
                                                id="too"
                                                // max={moment().add(0, 'days')}
                                                value={form.too}
                                                isGregorian={false}
                                                onChange={value => handleChangeDate(value, "too")}
                                            />
                                            */
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        {!isLoading && (
                            form.mode == "5" ||
                            form.mode == "6" ||
                            (form.mode == "3" && form.id != -1) ||
                            ((form.mode == "10" && form.modeAccount == 0) &&
                                form.id != -1)
                        ) &&
                            <div className="alert alert-secondary" role="alert">
                                {`میزان ${(form.mode == "5" ? " مسافت پیموده شده " :
                                    form.mode == "3" ? "مدت زمان روشن بودن خودرو" : " سوخت مصرف شده")} ${data} می باشد`}
                            </div>
                        }
                        {!isLoading &&
                            form.mode != 7 &&
                            form.mode != 11 &&
                            list.length > 0 &&
                            <button className="btn btn-primary" onClick={(e) => doExport(e, list)}>دانلود خروجی 1</button>}
                        {!isLoading && (
                            form.mode == 11 ||
                            (form.mode == 5 && form.id == -1) ||
                            (form.mode == 3 && form.id == -1) ||
                            (form.mode == 10 && (form.id == -1 || form.modeAccount == 1)))
                            && data != 0 &&
                            <button className="btn btn-primary" onClick={(e) => doExport3(e, list)}>دانلود خروجی 2</button>}
                        {!isLoading && form.mode == 7 && list.length > 0 &&
                            <button className="btn btn-primary" onClick={(e) => doExport2(e, list)}>دانلود خروجی 3</button>}
                        {!isLoading && form.mode == 7 && <ReportOnOff list={list} />}
                        {!isLoading && form.mode != 7 &&
                            form.mode != 11 &&
                            !(form.mode == 5 && form.id == -1) &&
                            !(form.mode == 3 && form.id == "-1") &&
                            list.length > 0 &&
                            <div className="row">
                                <div className="col">
                                    <div className="table-responsiv table-fixed">
                                        <table className="table  table-striped table-hover ">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ردیف</th>
                                                    <th scope="col">تاریخ</th>
                                                    <th scope="col">ساعت</th>
                                                    <th scope="col">{form.mode == "2" ? "سرعت"
                                                        : form.mode == "3" ? "زمان روشن بودن خودرو"
                                                            : form.mode == "4" ? "محدوده"
                                                                : form.mode == "5" ? "مسافت"
                                                                    : form.mode == "6" ? "مصرف سوخت"
                                                                        : form.mode == "8" ? "دما"
                                                                            : ""}</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list && list.map((item, index) => (
                                                    <tr key={index}>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{item.dtFa}</td>
                                                        <td>{item.time}</td>
                                                        <td>{form.mode == "2" ? item.speed
                                                            : form.mode == "3" ? item.switch
                                                                : form.mode == "8" ? item.temp
                                                                    : item.speed}</td>
                                                    </tr>)
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body >
                <Modal.Footer>
                    <Button variant="success" className="col btn btn-success btn-block myCustomButton"
                        onClick={handleAddIng}
                        disabled={isLoading}>
                        {isLoading &&
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>}
                        <span>&nbsp;&nbsp;&nbsp;تایید </span>
                    </Button>
                    <Button variant="danger" className="col btn btn-danger myCustomButton" data-bs-dismiss="modal"
                        onClick={handleCloseIng}>
                        <span>&nbsp;&nbsp;&nbsp;انصراف</span>
                    </Button>
                </Modal.Footer>
            </Modal >
        </>

    );

}
